import {
  NdcRelatedSchemasConfig,
  NdcSpreadsheetImportSubmissionValidationErrors,
  NdcSpreadsheetImportValidationErrorBadRequest,
} from 'antibodies/nested-data-creation/spreadsheet-import/constants/AntibodyNestedDataCreationSpreadsheetImportConstants';
import * as logging from 'util/Logging';

export function guardRelatedSchemasConfigIsValid(
  relatedSchemasConfig: NdcRelatedSchemasConfig,
  hasDnaColumns: boolean
): boolean {
  if (hasDnaColumns) {
    if (
      relatedSchemasConfig.dnaDomainSchemaId == null ||
      relatedSchemasConfig.dnaChainSchemaId == null ||
      relatedSchemasConfig.dnaPairSchemaId == null
    ) {
      return false;
    }
  }
  return relatedSchemasConfig.aaPairSchemaId != null;
}

export function guardSelectedProjectFolderIsValid(selectedProjectFolderId: string | null): boolean {
  return selectedProjectFolderId != null;
}

export function hasSubmissionValidationErrors(
  submissionValidationErrors: NdcSpreadsheetImportSubmissionValidationErrors | null | undefined
): boolean {
  return (
    (submissionValidationErrors?.validationErrors.length ?? 0) > 0 ||
    (submissionValidationErrors?.batchErrors.length ?? 0) > 0
  );
}

/** Extracts structured validation errors from an NDC submission BadRequestError. Returns null when the error
 * has no structured validation errors, in which case callers should treat it as an unexpected failure. */
export function getSubmissionValidationErrors(
  error: NdcSpreadsheetImportValidationErrorBadRequest
): NdcSpreadsheetImportSubmissionValidationErrors | null {
  const hasValidationErrorsField = error.validationErrors != null;
  const hasBatchErrorsField = error.batchErrors != null;
  if (!hasValidationErrorsField && !hasBatchErrorsField) {
    return null;
  }

  const submissionValidationErrors = {
    validationErrors: error.validationErrors ?? [],
    batchErrors: error.batchErrors ?? [],
  };
  if (hasSubmissionValidationErrors(submissionValidationErrors)) {
    return submissionValidationErrors;
  }

  logging.error('Received empty structured validation error response from NDC submission', {
    extra: {
      validationErrors: error.validationErrors,
      batchErrors: error.batchErrors,
    },
  });
  return null;
}
